import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Dialog, DialogTitle, DialogActions, Button } from '@material-ui/core';

const Root = styled(Box)({
})

class AlertDialog extends Component {
    constructor(props) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
    }
    render() {
        const { content, open, yesLabel, noLabel, widthSize } = this.props;
        return (
            <Root>
                <Dialog
                    open={open ? open : false}
                    fullWidth={true}
                    maxWidth={widthSize ? widthSize : "sm"}
                >
                    <DialogTitle
                        className="c"
                        style={{
                            color: "#005E96",
                            fontSize: "18px",
                            fontWeight: "bold",
                        }}
                    >
                        {content}
                    </DialogTitle>
                    <div className="line" style={{
                        width: '90%',
                        height: '1px',
                        backgroundColor: '#A1A1A1',
                        opacity: '0.12',
                        margin: '20px auto',
                    }}></div>
                    <DialogActions className="c">
                        <div className="h" style={{ marginBottom: "20px" }}>
                            <Button
                                onClick={e => this.handleClose(e, false, true)}
                                variant="contained"
                                style={{ minWidth: "120px", }}
                            >
                                {yesLabel ? yesLabel : "Cancel"}
                            </Button>
                            <Button
                                onClick={e => this.handleClose(e, true)}
                                variant="contained"
                                color="primary"
                                autoFocus
                                style={{ minWidth: "120px", marginLeft: "25px" }}
                            >
                                {noLabel ? noLabel : "Confirm"}
                            </Button>
                        </div>
                    </DialogActions>
                </Dialog>
            </Root>
        )
    }
    handleClose(e, isRight, isRealClick = false) {
        if (isRight) {
            this.props.handleAlertYes();
        } else {
            this.props.handleAlertNo(isRealClick);
        }
    }
}

export default AlertDialog;